import OneTimeOrderSelection from './OneTimeOrderSelection';

export default OneTimeOrderSelection;
